import './style.css';
import React from "react";
import ReactDOM from "react-dom";
import { ThemeProvider } from '@mui/material/styles';
import App from "./app";
import theme from "./theme";
import { captureAttributionFromUrl } from "./attribution";

// 着地ページの URL に広告のクリック識別子があれば保存する（ルーティングより前に 1 回だけ）
captureAttributionFromUrl();

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
